import React from 'react';
import { Paper, Typography } from '@mui/material';
import { Contractor } from '../../../types';

interface ContractorPerformanceSectionProps {
  contractor: Contractor;
}

const ContractorPerformanceSection: React.FC<ContractorPerformanceSectionProps> = ({ contractor }) => {
  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>
        Performance & KPIs
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Performance metrics and KPIs for {contractor.name} will be displayed here.
      </Typography>
    </Paper>
  );
};

export default ContractorPerformanceSection;

